import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Shield, Star, Globe, Clock, UserCheckIcon, CameraIcon, Globe2Icon, HeartPulseIcon, LockIcon, HeadphonesIcon, SparklesIcon } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-dark-800 relative" data-id="element-10">
      <div className="max-w-7xl mx-auto px-6" data-id="element-11">
        {/* Section Header */}
        <div className="text-center mb-20" data-id="element-12">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif text-white mb-4" data-id="element-13">
            关于 <span className="text-gold-500" data-id="element-14">TTvip</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gold-500/60 uppercase tracking-[0.2em] text-sm" data-id="element-15">
            About Us
          </motion.p>
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="w-24 h-px bg-gold-500 mx-auto mt-8" data-id="element-16" />
        </div>

        {/* ── Brand Story ── */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto text-center mb-24" data-id="element-17">
          <SparklesIcon className="w-8 h-8 text-gold-500/60 mx-auto mb-8" data-id="element-18" />

          <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-6 font-light" data-id="element-19">
            <span className="text-gold-400 font-serif text-lg md:text-xl" data-id="element-20">
              TTVIP
            </span>{' '}
            创立于2014年，扎根新加坡，历经十年深耕，从一家精品伴游服务发展为本地区最受信赖的高端伴游平台。我们始终秉持
            <span className="text-gold-400" data-id="element-21">"质量至上"</span>
            的核心理念——每一位佳丽均经过亲自甄选，每一次体验皆为精心策划，只为呈现超越期待的尊享时光。
          </p>

          <p className="text-gray-500 text-sm leading-relaxed mb-8" data-id="element-22">
            Founded in 2014 in Singapore, TTVIP has grown over a decade from a
            boutique companion service into the region's most trusted premium
            platform. We uphold a philosophy of{' '}
            <span className="text-gold-500/80 italic" data-id="element-23">
              quality over quantity
            </span>{' '}
            — every companion is personally vetted, every experience
            meticulously curated, delivering moments that exceed expectations.
          </p>

          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="w-16 h-px bg-gradient-to-r from-transparent via-gold-500/50 to-transparent mx-auto" data-id="element-24" />
        </motion.div>

        {/* ── Stats Grid (existing) ── */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-24 border-y border-white/5 py-12" data-id="element-25">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0
        }} className="text-center" data-id="element-26">
            <div className="text-4xl md:text-5xl font-serif text-gold-400 mb-2" data-id="element-27">
              10+
            </div>
            <div className="text-white font-medium text-sm md:text-base" data-id="element-28">
              十年专注
            </div>
            <div className="text-gray-600 text-xs uppercase tracking-wider mt-1" data-id="element-29">
              Years Experience
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-center" data-id="element-30">
            <div className="text-4xl md:text-5xl font-serif text-gold-400 mb-2" data-id="element-31">
              500+
            </div>
            <div className="text-white font-medium text-sm md:text-base" data-id="element-32">
              优质佳丽
            </div>
            <div className="text-gray-600 text-xs uppercase tracking-wider mt-1" data-id="element-33">
              Elite Companions
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-center" data-id="element-34">
            <div className="text-4xl md:text-5xl font-serif text-gold-400 mb-2" data-id="element-35">
              50k+
            </div>
            <div className="text-white font-medium text-sm md:text-base" data-id="element-36">
              尊贵客户
            </div>
            <div className="text-gray-600 text-xs uppercase tracking-wider mt-1" data-id="element-37">
              Happy Clients
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="text-center" data-id="element-38">
            <div className="text-4xl md:text-5xl font-serif text-gold-400 mb-2" data-id="element-39">
              99%
            </div>
            <div className="text-white font-medium text-sm md:text-base" data-id="element-40">
              好评率
            </div>
            <div className="text-gray-600 text-xs uppercase tracking-wider mt-1" data-id="element-41">
              Satisfaction
            </div>
          </motion.div>
        </div>

        {/* ── Features Grid (existing) ── */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-24" data-id="element-42">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="group p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] hover:border-gold-500/30 transition-all duration-500" data-id="element-43">
            <Star className="w-10 h-10 text-gold-500 mb-6 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-44" />
            <h3 className="text-xl text-white font-serif mb-1" data-id="element-45">专业服务</h3>
            <h4 className="text-xs text-gold-500/70 uppercase tracking-widest mb-4" data-id="element-46">
              Professional Service
            </h4>
            <p className="text-gray-500 text-sm leading-relaxed group-hover:text-gray-400 transition-colors" data-id="element-47">
              Strictly vetted companions ensuring the highest quality
              encounters.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="group p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] hover:border-gold-500/30 transition-all duration-500" data-id="element-48">
            <Globe className="w-10 h-10 text-gold-500 mb-6 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-49" />
            <h3 className="text-xl text-white font-serif mb-1" data-id="element-50">全球佳丽</h3>
            <h4 className="text-xs text-gold-500/70 uppercase tracking-widest mb-4" data-id="element-51">
              Global Selection
            </h4>
            <p className="text-gray-500 text-sm leading-relaxed group-hover:text-gray-400 transition-colors" data-id="element-52">
              Diverse selection from Japan, Korea, Europe, and beyond.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="group p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] hover:border-gold-500/30 transition-all duration-500" data-id="element-53">
            <Shield className="w-10 h-10 text-gold-500 mb-6 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-54" />
            <h3 className="text-xl text-white font-serif mb-1" data-id="element-55">隐私保护</h3>
            <h4 className="text-xs text-gold-500/70 uppercase tracking-widest mb-4" data-id="element-56">
              Privacy Guaranteed
            </h4>
            <p className="text-gray-500 text-sm leading-relaxed group-hover:text-gray-400 transition-colors" data-id="element-57">
              Your discretion and privacy are our absolute top priorities.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="group p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] hover:border-gold-500/30 transition-all duration-500" data-id="element-58">
            <Clock className="w-10 h-10 text-gold-500 mb-6 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-59" />
            <h3 className="text-xl text-white font-serif mb-1" data-id="element-60">全天候支持</h3>
            <h4 className="text-xs text-gold-500/70 uppercase tracking-widest mb-4" data-id="element-61">
              24/7 Support
            </h4>
            <p className="text-gray-500 text-sm leading-relaxed group-hover:text-gray-400 transition-colors" data-id="element-62">
              Dedicated concierge team ready to assist you at any time.
            </p>
          </motion.div>
        </div>

        {/* ── Platform Advantages ── */}
        <div className="mb-24" data-id="element-63">
          <div className="text-center mb-16" data-id="element-64">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-5xl font-serif text-white mb-4" data-id="element-65">
              平台<span className="text-gold-500" data-id="element-66">优势</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-gold-500/60 uppercase tracking-[0.2em] text-sm" data-id="element-67">
              Platform Advantages
            </motion.p>
            <motion.div initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2,
            duration: 0.8
          }} className="w-24 h-px bg-gold-500 mx-auto mt-8" data-id="element-68" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-69">
            {/* 严格甄选 */}
            <motion.div initial={{
            opacity: 0,
            y: 25
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.05
          }} className="group p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] hover:border-gold-500/20 transition-all duration-500" data-id="element-70">
              <div className="flex items-start gap-5" data-id="element-71">
                <div className="w-12 h-12 rounded-full border border-gold-500/30 flex items-center justify-center flex-shrink-0 group-hover:bg-gold-500/10 transition-colors duration-500" data-id="element-72">
                  <UserCheckIcon className="w-5 h-5 text-gold-500" data-id="element-73" />
                </div>
                <div data-id="element-74">
                  <h3 className="text-lg text-white font-serif mb-1" data-id="element-75">
                    严格甄选
                  </h3>
                  <h4 className="text-[11px] text-gold-500/60 uppercase tracking-widest mb-3" data-id="element-76">
                    Rigorous Selection
                  </h4>
                  <p className="text-gray-400 text-sm leading-relaxed mb-2" data-id="element-77">
                    每位佳丽经过多轮面试与背景审核，确保品质与安全。
                  </p>
                  <p className="text-gray-600 text-xs leading-relaxed" data-id="element-78">
                    Multi-round interviews and thorough background checks for
                    every companion, ensuring quality and safety at every level.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* 真实照片 */}
            <motion.div initial={{
            opacity: 0,
            y: 25
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="group p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] hover:border-gold-500/20 transition-all duration-500" data-id="element-79">
              <div className="flex items-start gap-5" data-id="element-80">
                <div className="w-12 h-12 rounded-full border border-gold-500/30 flex items-center justify-center flex-shrink-0 group-hover:bg-gold-500/10 transition-colors duration-500" data-id="element-81">
                  <CameraIcon className="w-5 h-5 text-gold-500" data-id="element-82" />
                </div>
                <div data-id="element-83">
                  <h3 className="text-lg text-white font-serif mb-1" data-id="element-84">
                    真实照片
                  </h3>
                  <h4 className="text-[11px] text-gold-500/60 uppercase tracking-widest mb-3" data-id="element-85">
                    Verified Photos
                  </h4>
                  <p className="text-gray-400 text-sm leading-relaxed mb-2" data-id="element-86">
                    所有照片均为真人实拍，拒绝虚假宣传，所见即所得。
                  </p>
                  <p className="text-gray-600 text-xs leading-relaxed" data-id="element-87">
                    All photos are authentic and verified — no misleading
                    content, what you see is what you get.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* 多元选择 */}
            <motion.div initial={{
            opacity: 0,
            y: 25
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15
          }} className="group p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] hover:border-gold-500/20 transition-all duration-500" data-id="element-88">
              <div className="flex items-start gap-5" data-id="element-89">
                <div className="w-12 h-12 rounded-full border border-gold-500/30 flex items-center justify-center flex-shrink-0 group-hover:bg-gold-500/10 transition-colors duration-500" data-id="element-90">
                  <Globe2Icon className="w-5 h-5 text-gold-500" data-id="element-91" />
                </div>
                <div data-id="element-92">
                  <h3 className="text-lg text-white font-serif mb-1" data-id="element-93">
                    多元选择
                  </h3>
                  <h4 className="text-[11px] text-gold-500/60 uppercase tracking-widest mb-3" data-id="element-94">
                    Diverse Options
                  </h4>
                  <p className="text-gray-400 text-sm leading-relaxed mb-2" data-id="element-95">
                    日韩、欧美、越南、中国等全球佳丽汇聚，满足不同品味与偏好。
                  </p>
                  <p className="text-gray-600 text-xs leading-relaxed" data-id="element-96">
                    Companions from Japan, Korea, Europe, Vietnam, China and
                    beyond — curated to match every taste and preference.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* 安全保障 */}
            <motion.div initial={{
            opacity: 0,
            y: 25
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="group p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] hover:border-gold-500/20 transition-all duration-500" data-id="element-97">
              <div className="flex items-start gap-5" data-id="element-98">
                <div className="w-12 h-12 rounded-full border border-gold-500/30 flex items-center justify-center flex-shrink-0 group-hover:bg-gold-500/10 transition-colors duration-500" data-id="element-99">
                  <HeartPulseIcon className="w-5 h-5 text-gold-500" data-id="element-100" />
                </div>
                <div data-id="element-101">
                  <h3 className="text-lg text-white font-serif mb-1" data-id="element-102">
                    安全保障
                  </h3>
                  <h4 className="text-[11px] text-gold-500/60 uppercase tracking-widest mb-3" data-id="element-103">
                    Safety First
                  </h4>
                  <p className="text-gray-400 text-sm leading-relaxed mb-2" data-id="element-104">
                    定期健康检查，严格卫生标准，全方位保障双方安全与健康。
                  </p>
                  <p className="text-gray-600 text-xs leading-relaxed" data-id="element-105">
                    Regular health screenings and strict hygiene standards,
                    ensuring complete safety and wellbeing for all parties.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* 隐私至上 */}
            <motion.div initial={{
            opacity: 0,
            y: 25
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.25
          }} className="group p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] hover:border-gold-500/20 transition-all duration-500" data-id="element-106">
              <div className="flex items-start gap-5" data-id="element-107">
                <div className="w-12 h-12 rounded-full border border-gold-500/30 flex items-center justify-center flex-shrink-0 group-hover:bg-gold-500/10 transition-colors duration-500" data-id="element-108">
                  <LockIcon className="w-5 h-5 text-gold-500" data-id="element-109" />
                </div>
                <div data-id="element-110">
                  <h3 className="text-lg text-white font-serif mb-1" data-id="element-111">
                    隐私至上
                  </h3>
                  <h4 className="text-[11px] text-gold-500/60 uppercase tracking-widest mb-3" data-id="element-112">
                    Absolute Privacy
                  </h4>
                  <p className="text-gray-400 text-sm leading-relaxed mb-2" data-id="element-113">
                    端到端加密通讯，绝不泄露任何客户信息，您的隐私就是我们的底线。
                  </p>
                  <p className="text-gray-600 text-xs leading-relaxed" data-id="element-114">
                    End-to-end encrypted communications with zero data leaks —
                    your privacy is our non-negotiable commitment.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* 专属管家 */}
            <motion.div initial={{
            opacity: 0,
            y: 25
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="group p-8 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] hover:border-gold-500/20 transition-all duration-500" data-id="element-115">
              <div className="flex items-start gap-5" data-id="element-116">
                <div className="w-12 h-12 rounded-full border border-gold-500/30 flex items-center justify-center flex-shrink-0 group-hover:bg-gold-500/10 transition-colors duration-500" data-id="element-117">
                  <HeadphonesIcon className="w-5 h-5 text-gold-500" data-id="element-118" />
                </div>
                <div data-id="element-119">
                  <h3 className="text-lg text-white font-serif mb-1" data-id="element-120">
                    专属管家
                  </h3>
                  <h4 className="text-[11px] text-gold-500/60 uppercase tracking-widest mb-3" data-id="element-121">
                    Personal Concierge
                  </h4>
                  <p className="text-gray-400 text-sm leading-relaxed mb-2" data-id="element-122">
                    24小时专属客服团队，从预约到体验全程贴心服务，让您无忧尽享。
                  </p>
                  <p className="text-gray-600 text-xs leading-relaxed" data-id="element-123">
                    A dedicated 24/7 concierge team accompanies you from booking
                    through experience, ensuring a seamless journey.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* ── Brand Commitment ── */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-124">
          <div className="p-px rounded-sm bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-125">
            <div className="bg-dark-800 p-10 md:p-16 text-center border border-white/[0.03]" data-id="element-126">
              <div className="w-10 h-px bg-gold-500 mx-auto mb-8" data-id="element-127" />

              <motion.p initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="text-2xl md:text-3xl font-serif text-white mb-3 leading-snug" data-id="element-128">
                我们的承诺：不只是服务，
                <br className="hidden md:block" data-id="element-129" />
                更是一种<span className="text-gold-500" data-id="element-130">生活方式</span>的体验
              </motion.p>

              <motion.p initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} className="text-gold-500/50 text-sm uppercase tracking-[0.15em] italic mb-10" data-id="element-131">
                Our Promise: Not just a service, but a lifestyle experience
              </motion.p>

              <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4
            }} className="max-w-2xl mx-auto space-y-4" data-id="element-132">
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-133">
                  TTVIP始终致力于为每一位客户打造超越期待的尊享体验。我们不断优化服务流程、提升佳丽品质、完善安全保障体系，只为让您在新加坡的每一刻都成为珍贵的回忆。选择TTVIP，选择品质与信赖。
                </p>
                <p className="text-gray-600 text-xs leading-relaxed" data-id="element-134">
                  TTVIP is dedicated to crafting experiences that exceed
                  expectations for every client. We continuously refine our
                  service processes, elevate companion quality, and strengthen
                  our safety systems — so that every moment you spend in
                  Singapore becomes a treasured memory. Choose TTVIP. Choose
                  quality and trust.
                </p>
              </motion.div>

              <div className="w-10 h-px bg-gold-500 mx-auto mt-8" data-id="element-135" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}